const createAboutUsComponent = () => `
  <div class="container" data-aos="fade-up">
    <div class="section-header">
      <h2>Tentang Kami</h2>
      <p>KSB hadir sebagai wadah generasi muda yang memiliki wawasan dan kepedulian terhadap kelestarian lingkungan di wilayah Karesidenan Surakarta. Kami berkomitmen untuk menjalin kolaborasi dengan pemerintah dan seluruh bagian masyarakat dalam meningkatkan kepedulian lingkungan, berperan aktif dalam penanggulangan dan perbaikan kerusakan lingkungan, memberikan edukasi kepada masyarakat, serta menjalankan tugas dan kewajiban kami sebagai anggota komunitas dengan penuh tanggung jawab.</p>
      <div class="position-relative mt-4">
        <img src="https://i.ibb.co.com/bJWhrks/image.png" class="img-fluid rounded-4 custom-img-up" alt="" />
        <a href="https://youtu.be/CW6lL4j-2Qo?si=v8tUTpxfVPY-x1Xx" class="glightbox play-btn"></a>
      </div>
    </div>
    <div class="row gy-4">
      <div class="col-lg-6">
        <h3>Sejarah</h3>
        <img src="https://i.ibb.co.com/Lpws3sp/IMG-20220918-WA0090.jpg" class="img-fluid rounded-4 mb-4 custom-img" alt="" />
        <p>
          Komunitas Solo Bersih (KSB) didirikan pada tanggal 21 September 2019 di kota Surakarta. Pendirian ini bertujuan untuk menjawab kebutuhan akan sebuah wadah yang dapat menggerakkan dan menyatukan generasi muda serta masyarakat umum dalam upaya pelestarian lingkungan. Sekretariat KSB bertempat di Papan Kawruh Tirta, Gilingan, Banjarsari, Surakarta, Jawa Tengah.
          Berdasarkan asas kekeluargaan dan kebersamaan yang ditopang oleh nilai-nilai Pancasila dan Undang-Undang Dasar 1945, KSB memiliki visi untuk menjadi wadah generasi muda yang berwawasan dan peduli terhadap lingkungan. Untuk mencapai visi tersebut, KSB mengemban misi menjalin kolaborasi dengan pemerintah dan masyarakat, berperan aktif dalam penanggulangan dan perbaikan kerusakan lingkungan, memberikan edukasi kepada masyarakat, serta berkomitmen dalam tugas dan kewajiban sebagai anggota komunitas.
        </p>
      </div>
      <div class="col-lg-6">
        <div class="content ps-0 ps-lg-5">
          <p class="paragraph">
            KSB didirikan untuk waktu yang tidak terbatas dengan tujuan menjadikan lingkungan di Karesidenan Surakarta tetap lestari dan berseri. Selain itu, KSB juga berupaya meningkatkan kesadaran bahwa lingkungan yang kita tempati bukan hanya warisan nenek moyang, namun juga pinjaman dari generasi anak cucu kita, sehingga kita berkewajiban untuk menjaga dan merawatnya. Sebagai bagian dari masyarakat Karesidenan Surakarta, KSB turut berperan aktif membantu program pemerintah dalam permasalahan lingkungan dan sosial kemasyarakatan.
            Untuk mencapai tujuan tersebut, KSB yang terdiri dari pemuda dan masyarakat umum yang peduli terhadap lingkungan, menyelenggarakan berbagai usaha dan kegiatan yang bertujuan meningkatkan kepedulian masyarakat tentang keberlanjutan alam sekitar.
          </p>
          <img src="https://i.ibb.co.com/sg7ZB1Y/IMG-20220918-WA0073.jpg" class="img-fluid rounded-4 mb-4 custom-img" alt="" />
        </div>
      </div>
    </div>
  </div>
`;

const createStatsCounterComponent = () => `

  <div class="container" data-aos="fade-up">
    <div class="row gy-4 align-items-center">
      <div class="col-lg-6">
        <img src="/img/stats-img.svg" alt="" class="img-fluid" />
      </div>
      <div class="col-lg-6">
        <div class="stats-item d-flex align-items-center">
          <span data-purecounter-start="0" data-purecounter-end="19" data-purecounter-duration="1" class="purecounter"></span>
          <p><strong>Pembersihan lingkungan</strong> yang pernah kami lakukan</p>
        </div>
        <div class="stats-item d-flex align-items-center">
          <span data-purecounter-start="0" data-purecounter-end="25" data-purecounter-duration="1" class="purecounter"></span>
          <p><strong>Kunjungan ke Sekolah</strong> yang pernah kami lakukan</p>
        </div>
        <div class="stats-item d-flex align-items-center">
          <span data-purecounter-start="0" data-purecounter-end="14" data-purecounter-duration="1" class="purecounter"></span>
          <p><strong>Kolaborasi</strong> yang pernah kami lakukan</p>
        </div>
      </div>
    </div>
  </div>
`;

const createTeamComponent = () => `
  <div class="container py-5" data-aos="fade-up">
    <div class="section-header">
      <h2>Tim Kami</h2>
      <p>Kenali anggota tim hebat di balik Komunitas Solo Bersih. Inilah orang-orang yang berdedikasi dalam menjaga dan memperbaiki lingkungan kita.</p>
    </div>
    <div class="row gy-4">
      <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="100">
        <div class="member">
          <img src="img/team/team-1.png" class="img-fluid" alt="Muhammad Ikhsan" />
          <h4>Muhammad Ikhsan</h4>
          <span>Ketua</span>
          <div class="social">
            <a href=""><i class="bi bi-twitter"></i></a>
            <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="200">
        <div class="member">
          <img src="img/team/team-2.png" class="img-fluid" alt="Nawang Wulan" />
          <h4>Nawang Wulan</h4>
          <span>Sekretaris</span>
          <div class="social">
            <a href=""><i class="bi bi-twitter"></i></a>
            <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="300">
        <div class="member">
          <img src="img/team/team-3.png" class="img-fluid" alt="Ade Firdaus" />
          <h4>Ade Firdaus</h4>
          <span>Tim IT</span>
          <div class="social">
            <a href=""><i class="bi bi-twitter"></i></a>
            <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="400">
        <div class="member">
          <img src="img/team/team-4.png" class="img-fluid" alt="Dea Adira" />
          <h4>Dea Adira</h4>
          <span>Bendahara</span>
          <div class="social">
            <a href=""><i class="bi bi-twitter"></i></a>
            <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

const createGalleryComponent = (picture) => `
  <div class="col-xl-4 col-md-6 gallery-item ${picture.category}">
    <div class="gallery-wrap">
      <a href="${picture.imageUrl}" data-gallery="gallery-gallery-app" class="glightbox">
        <img src="https://i.ibb.co.com/BwC7Y79/image.png" data-src="${picture.imageUrl}" class="img-fluid h-100 lazyload" alt="${picture.title}" />
      </a>
    </div>
  </div>
`;

export {
  createAboutUsComponent, createStatsCounterComponent, createTeamComponent, createGalleryComponent,
};
